import type {
  AuditApiEntityType,
  AuditEntityConfigEntry,
  AuditEntitySlug,
} from "./auditTypes";

export const AUDIT_HISTORIES_LINK_LABEL = "Audit histories";

export const AUDIT_HISTORIES_LINK_TARGET = "_blank";
export const AUDIT_HISTORIES_LINK_REL = "noopener noreferrer";

export const AUDIT_ENTITY_CONFIG: Record<
  AuditEntitySlug,
  AuditEntityConfigEntry
> = {
  customer: { entityType: "CUSTOMER", label: "Customer" },
  product: { entityType: "PRODUCT", label: "Product" },
  allergen: { entityType: "ALLERGEN", label: "Allergen" },
  claim: { entityType: "CLAIM", label: "Claim" },
  preservative: { entityType: "PRESERVATIVE", label: "Preservative" },
  "product-type": { entityType: "PRODUCT_TYPE", label: "Product type" },
  "certification-type": {
    entityType: "CERTIFICATION_TYPE",
    label: "Certification type",
  },
  brand: { entityType: "BRAND", label: "Brand" },
  "unit-of-measure": {
    entityType: "UNIT_OF_MEASURE",
    label: "Unit of measure",
  },
  "tax-rate": { entityType: "TAX_RATE", label: "Tax rate" },
  "assembly-item": { entityType: "ASSEMBLY_ITEM", label: "Assembly item" },
  "bom-items": { entityType: "MY_INGREDIENT", label: "My ingredient" },
  manufacturer: { entityType: "MANUFACTURER", label: "Manufacturer" },
  order: { entityType: "ORDER", label: "Order" },
  "purchase-order": {
    entityType: "PURCHASE_ORDER",
    label: "Purchase order",
  },
  shipment: { entityType: "SHIPMENT", label: "Shipment" },
  "receiving-invoice": {
    entityType: "RECEIVING_INVOICE",
    label: "Receiving invoice",
  },
  "manufactured-product": {
    entityType: "MANUFACTURED_PRODUCT",
    label: "Manufactured product",
  },
  "visitor-type": { entityType: "VISITOR_TYPE", label: "Visitor type" },
  equipment: { entityType: "EQUIPMENT", label: "Equipment" },
  laboratory: { entityType: "LABORATORY", label: "Laboratory" },
  "visitor-log": { entityType: "VISITOR_LOG", label: "Visitor log" },
  "lab-sample": { entityType: "LAB_SAMPLE", label: "Lab sample" },
  "tenant-settings": {
    entityType: "TENANT_SETTINGS",
    label: "Company settings",
  },
  recipe: { entityType: "RECIPE", label: "Recipe" },
  media: { entityType: "MEDIA", label: "Media" },
  user: { entityType: "USER", label: "User" },
  location: { entityType: "LOCATION", label: "Location" },
  "location-zone": {
    entityType: "LOCATION_ZONE",
    label: "Location zone",
  },
  "location-production-room": {
    entityType: "LOCATION_PRODUCTION_ROOM",
    label: "Location production room",
  },
};

export function getAuditEntityConfig(
  slug: string | undefined | null,
): AuditEntityConfigEntry | null {
  if (!slug) return null;
  return AUDIT_ENTITY_CONFIG[slug.toLowerCase() as AuditEntitySlug] ?? null;
}

export function getAuditApiEntityType(
  slug: AuditEntitySlug,
): AuditApiEntityType | null {
  return AUDIT_ENTITY_CONFIG[slug]?.entityType ?? null;
}

export function buildAuditUrl(
  slug: AuditEntitySlug | string,
  id: number | string,
  name?: string | null,
): string {
  const encodedName = encodeURIComponent(name ?? "");
  return `/audit/${slug}/${id}?name=${encodedName}`;
}

export function buildAuditHistoriesUrl(slug: AuditEntitySlug | string): string {
  return `/audit-histories/${slug}`;
}

export function auditHistoriesSetupAction(slug: AuditEntitySlug) {
  return {
    label: AUDIT_HISTORIES_LINK_LABEL,
    href: buildAuditHistoriesUrl(slug),
    variant: "gray" as const,
    target: AUDIT_HISTORIES_LINK_TARGET,
    rel: AUDIT_HISTORIES_LINK_REL,
  };
}
